import { REDUCE_SEND_PAYMENT_LINK_DTO } from '../../constants/actions/payment';

export function reduceSendPaymentLinkDto(payload) {
    return {
        type: REDUCE_SEND_PAYMENT_LINK_DTO,
        payload,
    };
}
